import React, { useContext, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { InputAdornment, Paper, Stack, useMediaQuery } from '@mui/material';
import { EmailOutlined, LockOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { styled } from '@mui/material/styles';
import AuthStore from '../../store/AuthStore';
import loginVectorImage from '../../assets/images/loginVectors.png';
import appLoginLogo from '../../assets/images/loginAppLogo.png';
import LoadingProgressStore from '../../store/LoadingProgressStore';

const defaultTheme = createTheme({
  typography: {
    button: {
      textTransform: 'none',
    },
  },
});

const CustomButton = styled(Button)({
  backgroundColor: '#FF7959',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#f1785a',
  },
  borderRadius: 20,
});

const Item = styled(Paper)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const ForgotPassword = observer(({}) => {
  const theme = createTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.includes('@')) {
      setEmailError(true);
      return;
    } else {
      setEmailError(false);
    }

    if (!emailError) {
      LoadingProgressStore.toggleIsLoading(true);
      AuthStore.forgotPassword(email);
    }
  };

  useEffect(() => {
    AuthStore.isAuthenticated && navigate('/home');
  }, [AuthStore.isAuthenticated]);

  return (
    // <ThemeProvider theme={defaultTheme}>
    <Grid container component="main" sx={{ height: '100vh', boxShadow: 'none' }}>
      <CssBaseline />
      {!isSmallScreen && (
        <Grid
          item
          xs={false}
          sm={false}
          md={6}
          lg={5}
          sx={{
            background: 'linear-gradient(#474DEB, #11158F)',
            height: '100vh',
            boxShadow: 'none',
          }}
        >
          <Item sx={{ height: '100%' }}>
            <div
              style={{
                background: 'linear-gradient(#474DEB, #11158F)',
                height: '100vh',
                position: 'relative',
              }}
            >
              <img src={loginVectorImage} alt="new-pipeline" style={{ height: '100vh' }}></img>
              <Stack
                direction={'column'}
                spacing={8}
                sx={{
                  position: 'absolute',
                  top: '20%',
                  color: '#fff',
                  padding: '2.5rem',
                }}
              >
                <Stack>
                  <img src={appLoginLogo} alt="app-full-logo" style={{ height: '3rem', width: 'fit-content' }}></img>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <h2>Smarter Leads, Bigger Wins</h2>
                  <p style={{ fontSize: '15px' }}>
                    The all-in-one solution to revolutionise your lead management process. Sign up today and take the
                    first step towards maximising your sales potential.
                  </p>
                </Stack>
              </Stack>
            </div>
          </Item>
        </Grid>
      )}
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={7}
        component={Paper}
        elevation={6}
        square
        sx={{ backgroundColor: '#F3FAFE', boxShadow: 'none' }}
      >
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <h1 style={{ marginRight: 'auto' }}>Forgot Password</h1>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                onChange={(e) => {
                  setEmailError(!e.target.validity.valid);
                  setEmail(e.target.value);
                }}
                value={email}
                error={!!emailError}
                helperText={emailError ? 'Please enter a valid email' : ''}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailOutlined />
                    </InputAdornment>
                  ),
                }}
                variant="standard"
                autoFocus
              />
              <CustomButton type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2, borderRadius: 20 }}>
                Recover Password
              </CustomButton>
              <Button
                fullWidth
                variant="contained"
                onClick={() => navigate('/login')}
                sx={{ mt: 3, mb: 2, borderRadius: 20 }}
              >
                Back To Login
              </Button>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
    // </ThemeProvider>
  );
});
